import React, { useState } from 'react';
type Status = 'idle' | 'loading' | 'success' | 'error';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <section className="border-y border-greige/70 bg-parchment" data-id="element-166" data-mp="3udcfn42s73av">
      <div className="mx-auto max-w-xl px-6 py-24 text-center lg:py-28" data-id="element-167" data-mp="38ca6kh2c3zk">
        <p className="eyebrow text-clay" data-id="element-168" data-mp="3lfa59xx5qyax">Private list</p>
        <h2 className="mt-4 font-display text-3xl font-light leading-tight text-ink lg:text-4xl" data-id="element-169" data-mp="3lgtljoitd9cp">
          Two letters a year. Nothing more.
        </h2>
        <p className="mt-4 text-sm font-light leading-relaxed text-smoke" data-id="element-170" data-mp="29yisz328c4wb">
          Early access to each small run, and notes from the atelier.
        </p>

        {status === 'success' ? <p className="mt-10 text-sm font-light text-ink" role="status" data-id="element-171" data-mp="2s3egwbgx4gm8">
            Thank you — you are on the list.
          </p> : <form onSubmit={handleSubmit} className="mt-10 flex flex-col gap-3 sm:flex-row" noValidate data-id="element-172" data-mp="2n5mqxmzu34ko">
            <label htmlFor="newsletter-email" className="sr-only" data-id="element-173" data-mp="31y6irrhj9pmt">
              Email address
            </label>
            <input id="newsletter-email" type="email" value={email} onChange={e => {
          setEmail(e.target.value);
          if (status === 'error') setStatus('idle');
        }} placeholder="Your email" aria-invalid={status === 'error'} className="flex-1 border border-greige bg-transparent px-4 py-3.5 text-sm font-light text-ink placeholder:text-smoke/70 focus:border-ink focus:outline-none" data-id="element-174" data-mp="3b0xulsebmnez" />
            <button type="submit" disabled={status === 'loading'} className="eyebrow border border-ink bg-ink px-8 py-3.5 text-bone transition-colors hover:bg-transparent hover:text-ink disabled:opacity-50" data-id="element-175" data-mp="3pr52je6pco1f">
              {status === 'loading' ? 'Sending…' : 'Subscribe'}
            </button>
          </form>}

        {status === 'error' && <p role="alert" className="mt-3 text-[11px] tracking-wide text-clay" data-id="element-176" data-mp="fdlofwjjy7jf">
            Please enter a valid email address.
          </p>}
      </div>
    </section>;
}